/* eslint-disable react/no-multi-comp */
import { LoadingOutlined } from '@ant-design/icons';
import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { lazy, Suspense, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UserTab from '../components/UserTab';
import { updateRegistry } from '../../../redux/actions/registryActions';

const UserAccountTab = lazy(() => import('../components/UserAccountTab'));
const UserWishListTab = lazy(() => import('../components/UserWishListTab'));
const UserOrdersTab = lazy(() => import('../components/UserFundTab'));

const Loader = () => (
  <div className="loader" style={{ minHeight: '80vh' }}>
    <LoadingOutlined />
    <h6>Loading ... </h6>
  </div>
);

const UserAccount = () => {
  useScrollTop();
  useDocumentTitle('My Account | My Breakup Registry');
  const {
    registry
  } = useSelector((state) => ({
    registry: state.profile.registry
  }));
  
  const dispatch = useDispatch();
  const [stateRegistry, setStateRegistry] = useState(registry);
  const handleUpdateRegistry = () => dispatch(updateRegistry({ registry: stateRegistry }));

  const deleteItem = (k) => () => {
    const newRegistry = [...stateRegistry.slice(0, k), ...stateRegistry.slice(k + 1)];
    setStateRegistry(newRegistry);
  };

  return (
    <UserTab handleUpdateRegistry={handleUpdateRegistry}>
      <div index={0} label="Account">
        <Suspense fallback={<Loader />}>
          <UserAccountTab />
        </Suspense>
      </div>
      <div index={1} label="My Wish List">
        <Suspense fallback={<Loader />}>
          <UserWishListTab
            stateRegistry={stateRegistry}
            setStateRegistry={setStateRegistry}
            deleteItem={deleteItem}
          />
        </Suspense>
      </div>
      <div index={2} label="My Funds">
        <Suspense fallback={<Loader />}>
          <UserOrdersTab />
        </Suspense>
      </div>
    </UserTab>
  );
};

export default UserAccount;
